module.exports = __webpack_public_path__ + "static/media/ubicacio.2f6ffe1f.svg";